import { PageMenu } from 'components/ideal-core-ui'

const MENU = [
  {
    key: 'yours',
    text: 'Your Templates'
  },
  {
    key: 'ideal',
    text: 'iDeal Library Templates'
  }
]

const Menu = ({ page, setPage }) => {
  return <PageMenu page={page} setPage={setPage} menu={MENU} />
}

export default Menu
